import { createContext } from 'react';

export const ErrorReportingContext = createContext({} as any);
